module.exports = __webpack_public_path__ + "img/14-min.3a63b77c.jpg";